import { Box, Center } from 'styled-system/jsx';
import Button from '@/common/components/base/button/Button.tsx';
import ArrowLeft from '@/common/assets/icons/leftPoint.svg?react';
import { token } from 'styled-system/tokens';

export default () => {
  return (
    <Center borderTop="1px solid {colors.gray-2}">
      <Button fullWidth variant="text" color="common">
        تعیین / ویرایش بازدید
      </Button>
      <Box height="30px" width="2px" backgroundColor="gray-2" />
      <Button gap="5px" fullWidth variant="text" color="primary">
        <ArrowLeft fill={token('colors.purple-2')} />
        ورود به صفحه پرونده
      </Button>
    </Center>
  );
};
